import AccordionTableItem from './AccordionTableItem'

export default AccordionTableItem
